import React from "react";
import { Loader2 } from "lucide-react";

export function FullScreenLoader({ label = "Loading…" }) {
  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-3 text-stone-400">
      <Loader2 className="h-7 w-7 animate-spin" strokeWidth={2.5} />
      <p className="text-sm font-medium">{label}</p>
    </div>
  );
}

export function InlineLoader({ label }) {
  return (
    <div className="flex items-center justify-center gap-2 py-10 text-stone-400">
      <Loader2 className="h-5 w-5 animate-spin" strokeWidth={2.5} />
      {label && <span className="text-sm font-medium">{label}</span>}
    </div>
  );
}
